import {subscriptionSvg as Icon__small__subscriptionSvg} from '../Icon__small/Icon__small--subscription.js';
import {subscriptionSvg as Icon__xsmall__subscriptionSvg} from '../Icon__xsmall/Icon__xsmall--subscription.js';

export var subscription = {
  name: 'subscription',
  category: 'icon',
  colorable: true,
  svg: Icon__small__subscriptionSvg,
  alt: {
    Icon__small: Icon__small__subscriptionSvg,
    Icon__xsmall: Icon__xsmall__subscriptionSvg,
  },
  combined: ['Icon__small', 'Icon__xsmall'],
};
